import { GlassmorphicCard } from '@/components/ui/glassmorphic-card'
import { User, Mail, Phone, MapPin, Award, BookOpen, Shield, Bell, LogOut } from 'lucide-react'

export function MentorProfileView() {
    return (
        <div className="space-y-6 pb-24 lg:pb-0">
            {/* Header / Profile Card */}
            {/* Header / Profile Card */}
            <div className="relative mb-6">
                <div className="h-48 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl"></div>
                <div className="px-6 md:px-10 -mt-20 relative flex flex-col md:flex-row items-start md:items-end gap-4">
                    <div className="w-32 h-32 rounded-2xl bg-white dark:bg-slate-900 p-1 shadow-lg shrink-0">
                        <div className="w-full h-full rounded-xl bg-gradient-to-br from-primary-blue to-indigo-600 flex items-center justify-center text-4xl font-bold text-white">
                            DS
                        </div>
                    </div>
                    <div className="mb-2 pt-2 md:pt-0">
                        <h2 className="text-2xl font-bold text-theme-primary">Dr. Sarah Johnson</h2>
                        <p className="text-theme-secondary">Senior Mentor • Physics & Chemistry Specialist</p>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Left Column - Info */}
                <div className="space-y-6">
                    <GlassmorphicCard className="p-6">
                        <h3 className="font-bold text-theme-primary mb-4 flex items-center gap-2">
                            <User className="h-5 w-5 text-primary-blue" />
                            Personal Information
                        </h3>
                        <div className="space-y-4">
                            <div className="flex items-center gap-3 text-sm">
                                <Mail className="h-4 w-4 text-theme-secondary" />
                                <span className="text-theme-primary">sarah.johnson@example.com</span>
                            </div>
                            <div className="flex items-center gap-3 text-sm">
                                <Phone className="h-4 w-4 text-theme-secondary" />
                                <span className="text-theme-primary">+91 98765 43210</span>
                            </div>
                            <div className="flex items-center gap-3 text-sm">
                                <MapPin className="h-4 w-4 text-theme-secondary" />
                                <span className="text-theme-primary">Bangalore, India</span>
                            </div>
                            <div className="flex items-center gap-3 text-sm">
                                <Award className="h-4 w-4 text-theme-secondary" />
                                <span className="text-theme-primary">Ph.D. in Physics</span>
                            </div>
                        </div>
                    </GlassmorphicCard>

                    <GlassmorphicCard className="p-6">
                        <h3 className="font-bold text-theme-primary mb-4 flex items-center gap-2">
                            <Award className="h-5 w-5 text-amber-500" />
                            Teaching Stats
                        </h3>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="p-3 bg-blue-50 dark:bg-blue-900/20 rounded-xl text-center">
                                <p className="text-2xl font-bold text-primary-blue">45</p>
                                <p className="text-xs text-theme-secondary">Students</p>
                            </div>
                            <div className="p-3 bg-green-50 dark:bg-green-900/20 rounded-xl text-center">
                                <p className="text-2xl font-bold text-green-600">4.8</p>
                                <p className="text-xs text-theme-secondary">Rating</p>
                            </div>
                            <div className="p-3 bg-purple-50 dark:bg-purple-900/20 rounded-xl text-center">
                                <p className="text-2xl font-bold text-purple-600">12</p>
                                <p className="text-xs text-theme-secondary">Batches</p>
                            </div>
                            <div className="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-xl text-center">
                                <p className="text-2xl font-bold text-amber-600">5yr</p>
                                <p className="text-xs text-theme-secondary">Experience</p>
                            </div>
                        </div>
                    </GlassmorphicCard>
                </div>

                {/* Right Column - Settings */}
                <div className="lg:col-span-2 space-y-6">
                    <GlassmorphicCard className="p-6">
                        <h3 className="font-bold text-theme-primary mb-4 flex items-center gap-2">
                            <BookOpen className="h-5 w-5 text-primary-blue" />
                            Teaching Preferences
                        </h3>
                        <div className="space-y-4">
                            <div className="flex items-center justify-between p-3 border border-slate-100 dark:border-slate-800 rounded-xl">
                                <div>
                                    <p className="font-semibold text-theme-primary text-sm">Subjects</p>
                                    <p className="text-xs text-theme-secondary">Primary subjects you mentor</p>
                                </div>
                                <div className="flex gap-2">
                                    <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900/20 text-blue-600 text-xs rounded-lg font-medium">Physics</span>
                                    <span className="px-2 py-1 bg-green-100 dark:bg-green-900/20 text-green-600 text-xs rounded-lg font-medium">Chemistry</span>
                                </div>
                            </div>
                            <div className="flex items-center justify-between p-3 border border-slate-100 dark:border-slate-800 rounded-xl">
                                <div>
                                    <p className="font-semibold text-theme-primary text-sm">Availability</p>
                                    <p className="text-xs text-theme-secondary">Set your mentoring hours</p>
                                </div>
                                <span className="text-sm font-medium text-theme-primary">Mon-Sat, 10 AM - 8 PM</span>
                            </div>
                        </div>
                    </GlassmorphicCard>

                    <GlassmorphicCard className="p-6">
                        <h3 className="font-bold text-theme-primary mb-4 flex items-center gap-2">
                            <Bell className="h-5 w-5 text-primary-blue" />
                            Notifications
                        </h3>
                        <div className="space-y-4">
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-theme-primary">Student Report Submissions</span>
                                <div className="w-10 h-6 bg-primary-blue rounded-full relative cursor-pointer">
                                    <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full"></div>
                                </div>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-theme-primary">New Messages</span>
                                <div className="w-10 h-6 bg-primary-blue rounded-full relative cursor-pointer">
                                    <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full"></div>
                                </div>
                            </div>
                            <div className="flex items-center justify-between">
                                <span className="text-sm text-theme-primary">System Updates</span>
                                <div className="w-10 h-6 bg-slate-200 dark:bg-slate-700 rounded-full relative cursor-pointer">
                                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full"></div>
                                </div>
                            </div>
                        </div>
                    </GlassmorphicCard>

                    <GlassmorphicCard className="p-6">
                        <h3 className="font-bold text-theme-primary mb-4 flex items-center gap-2">
                            <Shield className="h-5 w-5 text-primary-blue" />
                            Security
                        </h3>
                        <div className="flex items-center justify-between mb-4">
                            <div>
                                <p className="text-sm font-semibold text-theme-primary">Password</p>
                                <p className="text-xs text-theme-secondary">Last changed 3 months ago</p>
                            </div>
                            <button className="px-3 py-1.5 text-xs font-semibold text-primary-blue border border-primary-blue rounded-lg hover:bg-blue-50 dark:hover:bg-blue-900/20">
                                Change Password
                            </button>
                        </div>
                        <button className="w-full mt-2 flex items-center justify-center gap-2 text-red-500 font-semibold py-2 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors">
                            <LogOut className="h-4 w-4" />
                            Sign Out
                        </button>
                    </GlassmorphicCard>
                </div>
            </div>
        </div>
    )
}
